import React, { useState } from 'react';
import menuIcon from '../../assets/images/header/menu.svg';
import CallButton from './CallButton';
import useScrollPosition from '../../hooks/useScrollPosition';
import NavBar from "./NavBar";

function Header() {
  const isTop = useScrollPosition();
  const [responsiveMenu, setResponsiveMenu] = useState(false);

  const toggleResponsiveMenu = () => {
    setResponsiveMenu(prev => !prev);
  }

  const scrollToBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: 'smooth'
    });
    toggleResponsiveMenu();
  }

  const scrollToTop = () => {
    window.scrollTo({ top: 0 });
    toggleResponsiveMenu();
  }

  return (
    <header className={`bg-navy ${isTop ? "" : "shadow-lg"} flex justify-end sm:justify-between items-center z-50 p-5 h-24 fixed top-0 left-0 w-full transition-shadow ease-in-out duration-500`}>
      <h2 className="font-display font-bold text-white text-2xl left-6 -translate-y-10 sm:translate-y-0 absolute sm:relative sm:text-4xl mt-1 sm:ml-8 tracking-tight">MA Renovations</h2>

      <CallButton />

      <img className="xl:hidden" src={menuIcon} alt="menu icon" onClick={toggleResponsiveMenu}/>
      <NavBar responsiveMenu={responsiveMenu} scrollToTop={scrollToTop} scrollToBottom={scrollToBottom} />
    </header>
  );
}

export default Header;
